/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useRef, useState } from 'react';

import { debounce } from '../../utils/lodashUtils';

export default ({ url, isStaticSize = false, isPlayOnClick = false }) => {
  const [videoSize, setVideoSize] = useState({ height: '100%', width: '100%' });
  const videoElRef = useRef();

  const handleCheckVideoSizeInScreen = () => {
    if (isStaticSize) return;
    const windowSize = { height: window.innerHeight, width: window.innerWidth };

    const videoElement = videoElRef.current;
    if (!videoElement?.clientHeight || !videoElement?.videoHeight) return;

    const originalVideoSize = { height: videoElement.videoHeight, width: videoElement.videoWidth };
    const currentVideoSize = { height: videoElement.clientHeight, width: videoElement.clientWidth };

    originalVideoSize.scale = originalVideoSize.width / originalVideoSize.height;
    currentVideoSize.scale = currentVideoSize.width / currentVideoSize.height;
    currentVideoSize.width = videoElRef.current.clientWidth;

    const videoMaxHeight = windowSize.height - 132;

    if (videoMaxHeight > originalVideoSize.height) {
      setVideoSize({ height: '100%', width: '100%' });
      return;
    }

    const expectedVideoWidth = (videoMaxHeight * originalVideoSize.width) / originalVideoSize.height;
    if (expectedVideoWidth <= windowSize.width - 48) {
      if (expectedVideoWidth > 1280) {
        setVideoSize({ height: videoMaxHeight, width: 1280 });
        return;
      }

      setVideoSize({ height: videoMaxHeight, width: expectedVideoWidth });
      return;
    }

    const expectedVideoHeight = (originalVideoSize.height * currentVideoSize.width) / originalVideoSize.width;
    if (expectedVideoHeight <= videoMaxHeight) {
      setVideoSize({ height: expectedVideoHeight, width: '100%' });
      return;
    }

    setVideoSize({ height: videoMaxHeight, width: '100%' });
  };

  useEffect(() => {
    handleCheckVideoSizeInScreen();
    window.addEventListener('resize', debounce(handleCheckVideoSizeInScreen, 800));
    return () => {
      window.removeEventListener('resize', debounce(handleCheckVideoSizeInScreen, 800));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ alignItems: 'center', backgroundColor: 'black', display: 'flex', height: '100%', justifyContent: 'center', width: '100%' }}>
      <video
        autoPlay={!isPlayOnClick}
        controls
        ref={videoElRef}
        onLoadedData={handleCheckVideoSizeInScreen}
        style={{ height: videoSize.height, objectFit: 'contain', width: videoSize.width }}>
        <source src={url} />
      </video>
    </div>
  );
};
